import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import Headshot from "../components/Headshot";

import EventRow from "../components/EventRow";
import * as dayjs from "dayjs";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";
import FormMini from "../components/forms/FormMini";

import client from "../components/client";

export default function TemplatePage({ utm, events }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  let eventList = [];
  for (let event of events) {
    const now = dayjs();
    const eventDate =
      dayjs(event.event_date).format("MMM D, YYYY") != "Invalid Date" ? dayjs(event.event_date) : dayjs();

    if (event.event_type === "webinar" && eventList.length < 3 && eventDate > now) {
      eventList.push(event);
    }
  }
  if (eventList.length < 3) {
    for (let event of events) {
      if (event.event_type == "ondemand" && eventList.length < 3) {
        eventList.push(event);
      }
    }
  }

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Learning Portal - Elm Street Technology</title>
        <meta
          name="description"
          content="Online &amp; in-person education designed to educate, entertain &amp; inspire. Whether you are just starting your business journey, or are a seasoned professional looking to “up your game” with the latest tech tools, marketing masterminds, and on-going continuing education, Elm Street Academy is focused on supporting you every step of the way."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/learning_portal" />
        <meta property="og:title" content="Learning Portal - Elm Street" />
        <meta
          property="og:description"
          content="Online &amp; in-person education designed to educate, entertain &amp; inspire. Whether you are just starting your business journey, or are a seasoned professional looking to “up your game” with the latest tech tools, marketing masterminds, and on-going continuing education, Elm Street Academy is focused on supporting you every step of the way."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <ExitModal>
        <div
          style={{
            backgroundImage: "url('orangebg.webp')",
            backgroundPosition: "center",
            backgroundSize: "fixed",
            padding: "30px",
            display: "block",
          }}
        >
          <div style={{ textAlign: "center", paddingBottom: "20px" }}>
            {" "}
            <Typography
              variant="h3"
              component="h2"
              style={{ color: "#ffffff", textAlign: "center", paddingBottom: "10px" }}
            >
              Stay updated...
            </Typography>
            <Typography variant="h5" component="h2" style={{ color: "#333666", textAlign: "center" }}>
              with our free educational content!
            </Typography>
            <br />
            <strong>
              + Webinars
              <br />
              + Helpful Guides
              <br />
              + Marketing Tips
              <br />
              + AND MORE!
              <br />
            </strong>
          </div>
          <div style={{ backgroundColor: "#ffffff", padding: "25px" }}>
            <FormMini
              buttonText="Register Today For Updates"
              listId="147998"
              formName="es2_monday_mentor"
              utmOverride="exit_intent"
            />
          </div>
        </div>
      </ExitModal>

      <div>
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{ paddingBottom: "50px", textAlign: "center" }}>
            <div>
              <Image src="/es_academy_logo.svg" width="260px" height="90px" alt="Elm Street Academy" />
            </div>
            <Typography variant="h2" component="h1">
              <span style={{ color: mainTheme.palette.secondary.main }}>your</span> learning portal to success.
            </Typography>

            <div style={{ paddingTop: "30px" }}>
              <strong style={{ color: mainTheme.palette.secondary.main }}>
                Online &amp; in-person education designed to educate, entertain &amp; inspire.
              </strong>
              <br />
              Whether you are just starting your business journey, or are a seasoned professional looking to “up your
              game” with the latest tech tools, marketing masterminds, and on-going continuing education, Elm Street
              Academy is focused on supporting you every step of the way.
            </div>
          </div>

          <div style={{ textAlign: "center" }}>
            <Grid container columnSpacing={12}>
              <Grid item md={6} sm={12} xs={12} style={{ paddingBottom: "24px", textAlign: "center" }}>
                <strong>
                  High-Energy &amp; Interactive
                  <br />
                  Top Educators
                  <br />
                  Always Free
                </strong>
              </Grid>
              <Grid item md={6} sm={12} xs={12} style={{ paddingBottom: "24px", textAlign: "center" }}>
                <strong>
                  Virtual &amp; In-Person
                  <br />
                  Live &amp; On-Demand
                  <br />
                  Action-Oriented Education
                </strong>
              </Grid>
            </Grid>
          </div>

          <div style={{ paddingTop: "20px", textAlign: "center" }}>
            <Button variant="contained" color="secondary" href="/events">
              browse all events
            </Button>
          </div>
          <div style={{ paddingTop: "10px", textAlign: "center" }}>
            <Button variant="contained" color="secondary" href="/book_an_event" style={{ width: "236px" }}>
              book your event
            </Button>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('esbg2.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "110px", paddingBottom: "85px" }}>
          <Grid container columnSpacing={8}>
            <Grid item md={6} sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                <span style={{ color: "#f69c26" }}>
                  The #1 “Boot Camp”
                  <br />
                </span>
                Training Series
                <br />
                in Real Estate
              </Typography>
              <br />
              <strong style={{ color: "#f69c26" }}>TOPICS INCLUDE:</strong>
              <br />
              <span style={{ color: "#ffffff" }}>
                - Social Media
                <br />
                - Lead Generation
                <br />
                - Lead Nurturing
                <br />
                - Repeat/Referral
                <br />
                - Marketing Strategies
                <br />
                - Lead Conversion
                <br />
                - Technology Training
                <br />
                &amp; MUCH MORE!
              </span>
              <div style={{ paddingTop: "20px" }}>
                <Button variant="contained" color="secondary" href="#passion">
                  browse upcoming sessions
                </Button>
              </div>
            </Grid>

            <Grid item md={6} sm={12} style={{ paddingBottom: "24px", color: "#ffffff" }}>
              {eventList.map(function (event) {
                return <EventRow client={client} event={event} type={event.event_type} key={event._id} />;
              })}
            </Grid>
          </Grid>
        </Container>
      </div>

      <a id="passion" />
      <div
        style={{
          backgroundImage: "url('fadebg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "70px", paddingBottom: "85px" }}>
          <div style={{ paddingBottom: "33px", paddingTop: "33px" }}>
            <Typography variant="h5" component="h2">
              pick your <span style={{ color: mainTheme.palette.secondary.main }}>passion</span>
            </Typography>
            <strong>Hot topics for busy professionals.</strong>
          </div>

          <Grid container columnSpacing={10}>
            <Grid item md={3} sm={6} xs={6} style={{ paddingBottom: "33px", textAlign: "center" }}>
              <Headshot src="/socialmedia.jpg" name="" title="" alt="Elm Street Academy - Social Media" />
              <br />
              <div style={{ marginTop: "-20px" }}>
                <strong>
                  SOCIAL
                  <br />
                  MEDIA
                </strong>
              </div>
              <div style={{ paddingTop: "12px" }}>
                {/*
                <Button variant="contained" color="secondary" href="https://tryelevate.com/events_sm" target="_blank">
                  browse events
                </Button>
                */}
                <Button
                  variant="contained"
                  color="secondary"
                  href="/events?tab=regional&f=Social%20Media%20Boot%20Camp"
                >
                  browse events
                </Button>
              </div>
            </Grid>
            <Grid item md={3} sm={6} xs={6} style={{ paddingBottom: "33px", textAlign: "center" }}>
              <Headshot src="/leadgeneration.jpg" name="" title="" alt="Elm Street Academy - Lead Generation" />
              <br />
              <div style={{ marginTop: "-20px" }}>
                <strong>
                  LEAD
                  <br />
                  GENERATION
                </strong>
              </div>
              <div style={{ paddingTop: "12px" }}>
                {/*
                <Button variant="contained" color="secondary" href="https://tryelevate.com/events_lg" target="_blank">
                  browse events
                </Button>
              */}
                <Button
                  variant="contained"
                  color="secondary"
                  href="/events?tab=regional&f=Lead%20Generation%20Boot%20Camp"
                >
                  browse events
                </Button>
              </div>
            </Grid>
            <Grid item md={3} sm={6} xs={6} style={{ paddingBottom: "33px", textAlign: "center" }}>
              <Headshot src="/referral.jpg" name="" title="" alt="Elm Street Academy - Repeat &amp; Referral" />
              <br />
              <div style={{ marginTop: "-20px" }}>
                <strong>
                  REPEAT
                  <br />
                  &amp; REFERRAL
                </strong>
              </div>
              <div style={{ paddingTop: "12px" }}>
                {/*
                <Button
                  variant="contained"
                  color="secondary"
                  href="https://tryelevate.com/events_referrals"
                  target="_blank"
                >
                  browse events
                </Button>
                */}
                <Button variant="contained" color="secondary" href="/events?tab=regional&f=Referrals%20Boot%20Camp">
                  browse events
                </Button>
              </div>
            </Grid>

            <Grid item md={3} sm={6} xs={6} style={{ paddingBottom: "33px", textAlign: "center" }}>
              <Headshot src="/listings.jpg" name="" title="" alt="Elm Street Academy - Capture More Listings" />
              <br />
              <div style={{ marginTop: "-20px" }}>
                <strong>
                  GET MORE
                  <br />
                  LISTINGS
                </strong>
              </div>
              <div style={{ paddingTop: "12px" }}>
                {/*
                <Button
                  variant="contained"
                  color="secondary"
                  href="https://tryelevate.com/events_listings"
                  target="_blank"
                >
                  browse events
                </Button>
              */}
                <Button variant="contained" color="secondary" href="/events?tab=regional&f=Listings%20Boot%20Camp">
                  browse events
                </Button>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div style={{ backgroundColor: "#333666", paddingBottom: "45px", paddingTop: "85px" }}>
        <Container maxWidth="lg" style={{ PaddingTop: "75px", marginBottom: "48px" }}>
          <div style={{ textAlign: "center" }}>
            <span style={{ color: "#ffffff" }}>
              “I feel empowered and ready to conquer my marketing and lead generation, thanks to Elm Street's amazing
              educators. Building my business is so much easier than I thought!”
            </span>
            <strong style={{ color: "#f69c26" }}> - Ayesha D., Miami, FL</strong>
            <div style={{ paddingTop: "40px" }}>
              <Typography variant="h5" component="h5" style={{ color: "#ffffff" }}>
                Elm Street makes education <span style={{ color: "#f69c26" }}>FUN!</span>
              </Typography>
              <span style={{ color: "#ffffff" }}>
                Explore our top speakers and their specialties, and then connect with us!
              </span>
            </div>
            <div style={{ paddingTop: "12px" }}>
              <Button variant="contained" color="secondary" href="/book_an_event">
                book your next event
              </Button>
            </div>
          </div>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ paddingBottom: "45px", paddingTop: "25px" }}>
        <div style={{ paddingBottom: "33px", paddingTop: "83px" }}>
          <Typography variant="h5" component="h2">
            Meet our <span style={{ color: mainTheme.palette.secondary.main }}>educational team</span>
          </Typography>
        </div>

        <Grid container columnSpacing={8} style={{ paddingBottom: "45px", paddingTop: "35px" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
            <Headshot src="/headshots/salfonso.jpg" name="" title="" alt="Elm Street Academy - Stephanie Alfonso" />
          </Grid>
          <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
              stephanie alfonso
            </Typography>
            <strong>Director, Sales Enablement &amp; Solution Engineering</strong>
            <br />
            Stephanie brings encouragement, excitement and knowledge to social media marketing and online lead
            generation training. She has an insatiable desire to help agents at all levels, from brand new agents to
            seasoned top producers. Her empowering, high-energy teaching style and vast knowledge of online lead
            generation is well received and makes for compelling marketing and business growth and development events.
            <br />
            <br />
            <strong>SESSIONS:</strong> Social Media Boot Camps, Lead Generation Boot Camps, Referral Marketing
          </Grid>
        </Grid>

        <Grid container columnSpacing={8} style={{ paddingBottom: "45px" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
            <Headshot src="/headshots/tbauman.jpg" name="" title="" alt="Elm Street Academy - Tom Bauman" />
          </Grid>
          <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
              tom bauman
            </Typography>
            <strong>National Business Development Consultant</strong>
            <br />
            As a National Business Development Consultant, Tom has gained unique insight into the specific challenges
            facing agents across the country when it comes to their digital marketing strategies. Tom has a passion for
            helping agents overcome these obstacles and take control of their social media and online lead generation
            through education, motivation, and inspiration in order to drive tangible results in their businesses.
            <br />
            <br />
            <strong>SESSIONS:</strong> Social Media Boot Camps, Lead Generation Boot Camps, Referral Marketing
          </Grid>
        </Grid>

        <Grid container columnSpacing={8} style={{ paddingBottom: "45px" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
            <Headshot src="/headshots/shalladay.jpg" name="" title="" alt="Elm Street Academy - Stephen Halladay" />
          </Grid>
          <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
              stephen haladay
            </Typography>
            <strong>National Business Development Consultant</strong>
            <br />
            Since joining the Elevate Success Team, Stephen quickly became an audience favorite due to his
            straight-forward approach to all things digital marketing and lead generation. Approaching education with a
            millennial's mindset, he offers his audience a unique perspective on best practices to use social media to
            capture, engage and convert.
            <br />
            <br />
            <strong>SESSIONS:</strong> Social Media Boot Camps, Lead Generation Boot Camps, Referral Marketing
          </Grid>
        </Grid>

        <Grid container columnSpacing={8} style={{ paddingBottom: "45px" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
            <Headshot src="/headshots/brandonz.jpg" name="" title="" alt="Elm Street Academy - Brandon Zwingman" />
          </Grid>
          <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
              Brandon Zwingman
            </Typography>
            <strong>National Business Development Consultant</strong>
            <br />
            As a National Business Development Consultant, Brandon thrives on helping agents grow their business through
            social media marketing and online lead generation. From his years of experience as an entrepreneur, Brandon
            understands the unique challenges agents face. He brings this understanding along with his energetic and
            comprehensible teaching style to educational events nationwide.
            <br />
            <br />
            <strong>SESSIONS:</strong> Social Media Boot Camps, Lead Generation Boot Camps, Referral Marketing
          </Grid>
        </Grid>

        <Grid container columnSpacing={8} style={{ paddingBottom: "45px" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
            <Headshot src="/headshots/phollander.jpg" name="" title="" alt="Elm Street Academy - Phil Hollander" />
          </Grid>
          <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
              phil hollander
            </Typography>
            <strong>VP Business &amp; Professional Development</strong>
            <br />
            For over 20 years, Phil has been invited to speak at hundreds of real estate offices throughout North
            America and also to conferences to teach agents how to use referral and repeat marketing strategies to
            consistently grow a successful business.
            <br />
            <br />
            Phil is recognized in the real estate industry as a highly professional and knowledgeable speaker whose
            dynamic and high energy approach captivates audiences whether live or by webinar.
            <br />
            <br />
            Phil is the co-author of The Referral &amp; Repeat Marketing Book as well as the recently published book
            'Choice Points' When You Have to Decide Which Way to Go and the recently published Amazon #1 Best Selling
            Book, Million Dollar Agents, How Top Realtors Really Create High Income, Wealth and Independence.
            <br />
            <br />
            <strong>SESSIONS:</strong> Referral Marketing
          </Grid>
        </Grid>

        <Grid container columnSpacing={8} style={{ paddingBottom: "45px" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
            <Headshot src="/headshots/smcgee.jpg" name="" title="" alt="Elm Street Academy - Shannon McGee" />
          </Grid>
          <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
              shannon mcgee
            </Typography>
            <strong>Sales Director</strong>
            <br />
            Shannon McGee is the sales director for IXACT Contact Solutions Inc., a leading real estate CRM and
            marketing automation solution. McGee is responsible for customer onboarding, retention and support. She
            possesses years of experience and knowledge of CRM systems and holds a lot of enthusiasm for business
            automation.
            <br />
            <br />
            <strong>SESSIONS:</strong> Referral Marketing
          </Grid>
        </Grid>
      </Container>

      <MainFooter />
    </ThemeProvider>
  );
}

export async function getServerSideProps({ req, res }) {
  let cookies = getCookie("elmlead", { req, res });

  const eventQuery = `
  *[_type == "event" &&  !("Training" in event_category[]->title)] | order(event_date asc) {
    _id,
    title,
    event_date,
    event_type,
    event_category[]->{
      title
    },
    duration,
    description,
    thumbnail,
    reg_url,
    tags[]->{
      tag
    }
  }
  `;

  const events = await client.fetch(eventQuery);

  if (cookies) {
    return { props: { utm: cookies, events } };
  }
  return { props: { events } };
}
